/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DynamicQuantities } from '../models/DynamicQuantities';
import type { PurchaseOrderDetailsRead } from '../models/PurchaseOrderDetailsRead';
import type { PurchaseOrderLineDetailsRead } from '../models/PurchaseOrderLineDetailsRead';
import type { PurchaseOrderRead } from '../models/PurchaseOrderRead';
import type { PurchaseOrderSearchFields } from '../models/PurchaseOrderSearchFields';
import type { PurchaseOrderSearchRead } from '../models/PurchaseOrderSearchRead';
import type { UiEditContainer } from '../models/UiEditContainer';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PurchaseOrderService {

    /**
     * Get All Purchase Orders
     * @param limit
     * @param offset
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns PurchaseOrderRead Successful Response
     * @throws ApiError
     */
    public static getAllPurchaseOrdersPurchaseOrdersAllGet(
        limit?: (number | null),
        offset?: (number | null),
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<PurchaseOrderRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/purchase_orders/all',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get All Purchase Order Numbers
     * @param opco
     * @param limit
     * @param offset
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getAllPurchaseOrderNumbersPurchaseOrdersPurchaseOrderNumbersGet(
        opco: string,
        limit?: (number | null),
        offset?: (number | null),
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/purchase_orders/purchase_order_numbers',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'access_token': accessToken,
                'opco': opco,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Purchase Order Details
     * @param poNumber
     * @param opco
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns PurchaseOrderDetailsRead Successful Response
     * @throws ApiError
     */
    public static getPurchaseOrderDetailsPurchaseOrdersPoNumberDetailsGet(
        poNumber: string,
        opco: string,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<PurchaseOrderDetailsRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/purchase_orders/{po_number}/details',
            path: {
                'po_number': poNumber,
            },
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'opco': opco,
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Purchase Order Line Details
     * @param id
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns PurchaseOrderLineDetailsRead Successful Response
     * @throws ApiError
     */
    public static getPurchaseOrderLineDetailsPurchaseOrdersLineIdDetailsGet(
        id: number,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<PurchaseOrderLineDetailsRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/purchase_orders/line/{id}/details',
            path: {
                'id': id,
            },
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Search Purchase Orders
     * @param searchField
     * @param searchValue
     * @param opco
     * @param fullTextSearch
     * @returns PurchaseOrderSearchRead Successful Response
     * @throws ApiError
     */
    public static searchPurchaseOrdersPurchaseOrdersSearchGet(
        searchField: PurchaseOrderSearchFields,
        searchValue: string,
        opco: string,
        fullTextSearch: boolean = false,
    ): CancelablePromise<Array<PurchaseOrderSearchRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/purchase_orders/search',
            query: {
                'search_field': searchField,
                'search_value': searchValue,
                'full_text_search': fullTextSearch,
                'opco': opco,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Additional Po Lines
     * @param id
     * @returns UiEditContainer Successful Response
     * @throws ApiError
     */
    public static getAdditionalPoLinesPurchaseOrdersIdUnmatchedLinesGet(
        id: number,
    ): CancelablePromise<Array<UiEditContainer>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/purchase_orders/{id}/unmatched_lines',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Po Dynamic Quantities
     * @param id
     * @returns DynamicQuantities Successful Response
     * @throws ApiError
     */
    public static getPoDynamicQuantitiesPurchaseOrdersIdDynamicQuantitiesGet(
        id: number,
    ): CancelablePromise<Array<DynamicQuantities>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/purchase_orders/{id}/dynamic_quantities',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Po Line Dynamic Quantities
     * @param id
     * @returns DynamicQuantities Successful Response
     * @throws ApiError
     */
    public static getPoLineDynamicQuantitiesPurchaseOrdersLineIdDynamicQuantitiesGet(
        id: number,
    ): CancelablePromise<Array<DynamicQuantities>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/purchase_orders/line/{id}/dynamic_quantities',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
